import automationImage from 'images/marketplaceCTA.jpg';
import { TRACKING } from 'common/constants/constants';
import CtaPage from 'components/CtaPage';
import { Flex } from 'components/base/layout-components';

const SECTION_TYPES = {
  RECOMMENDED: 'RECOMMENDED',
  FILTERS: 'FILTERS',
  ALL_AUTOMATIONS: 'AUTOMATIONS'
};

const TEXTS = {
  [SECTION_TYPES.RECOMMENDED]: (
    <>
      Receive personalized <br />
      recommendations tailored to <br />
      your engineering <br />
      organization and <br />
      development practices. <br />
      Explore suggested <br /> automations designed to <br />
      enhance quality, security, <br />
      and efficiency based on <br />
      your organization's <br />
      technology stack, industry, <br />
      and metrics.
    </>
  ),
  [SECTION_TYPES.FILTERS]: (
    <>
      Quickly locate Git <br />
      automations by utilizing <br />
      search and sorting features.
    </>
  ),
  [SECTION_TYPES.ALL_AUTOMATIONS]: (
    <>
      Browse through a variety of <br />
      Git automations available in <br />
      the marketplace to discover <br />
      solutions that align best <br />
      with your specific use case. <br />
      Install selected automations <br />
      with just a few clicks to <br />
      streamline processes, save <br />
      time, enhance quality, and <br />
      enforce security standards <br />
      across your organization.
    </>
  )
};
const MarketplaceCTA = () => (
  <Flex grow='1' padding='small'>
    <CtaPage
      textsMap={TEXTS}
      page={TRACKING.PAGES.MARKETPLACE}
      pageTab={TRACKING.PAGE_TABS.MARKETPLACE_CTA}
      buttonLineProps={{
        leftText: 'automate your workflows!'.toUpperCase(),
        buttonText: 'SCHEDULE A WALKTHROUGH'
      }}
      backgroundImage={automationImage}
      sections={[
        {
          sectionType: SECTION_TYPES.FILTERS,
          buttonPosition: {
            left: '78%',
            top: '1.2rem'
          },
          coverProps: {
            height: '4.45rem',
            width: '100%',
            position: { top: 0 }
          },
          textPosition: { right: '-22rem', top: '0rem' }
        },
        {
          sectionType: SECTION_TYPES.RECOMMENDED,
          buttonPosition: {
            bottom: '40rem',
            left: '45rem'
          },

          coverProps: {
            height: '28.6rem',
            width: '100%',
            position: {
              top: '4.4rem',
              right: 0,
              bottom: '5rem'
            }
          },
          textPosition: { right: '-22rem', top: '7rem' }
        },
        {
          sectionType: SECTION_TYPES.ALL_AUTOMATIONS,
          buttonPosition: {
            bottom: '10rem',
            right: '55rem'
          },
          coverProps: {
            height: '18.45rem',
            width: '100%',
            position: { top: '33rem' }
          },
          textPosition: { right: '-22rem', top: '30rem' }
        }
      ]}
    />
  </Flex>
);

export default MarketplaceCTA;
